import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2387b9a7 from 'nuxt_plugin_plugin_2387b9a7' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_71e973c6 from 'nuxt_plugin_nuxtuseragent_71e973c6' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_7e8debb6 from 'nuxt_plugin_vuesocialsharingplugin_7e8debb6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_axios_624e9d86 from 'nuxt_plugin_axios_624e9d86' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_057c69ce from 'nuxt_plugin_workbox_057c69ce' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_a7622da8 from 'nuxt_plugin_metaplugin_a7622da8' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_9e12e2c0 from 'nuxt_plugin_iconplugin_9e12e2c0' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_Convert_3777be9b from 'nuxt_plugin_Convert_3777be9b' // Source: ../plugins/Convert.js (mode: 'all')
import nuxt_plugin_VeeValidate_0a77d762 from 'nuxt_plugin_VeeValidate_0a77d762' // Source: ../plugins/VeeValidate.js (mode: 'all')
import nuxt_plugin_Axios_4d2fd290 from 'nuxt_plugin_Axios_4d2fd290' // Source: ../plugins/Axios.js (mode: 'all')
import nuxt_plugin_VueGoogleMaps_6121fd98 from 'nuxt_plugin_VueGoogleMaps_6121fd98' // Source: ../plugins/VueGoogleMaps.js (mode: 'client')
import nuxt_plugin_VueAwesomeSwiper_135329ab from 'nuxt_plugin_VueAwesomeSwiper_135329ab' // Source: ../plugins/VueAwesomeSwiper.js (mode: 'client')
import nuxt_plugin_VueCarousel3d_f3ed7312 from 'nuxt_plugin_VueCarousel3d_f3ed7312' // Source: ../plugins/VueCarousel3d.js (mode: 'client')
import nuxt_plugin_VueBottomNavigation_fd82cf6e from 'nuxt_plugin_VueBottomNavigation_fd82cf6e' // Source: ../plugins/VueBottomNavigation.js (mode: 'client')
import nuxt_plugin_VueDeviceDetector_2f3d19cc from 'nuxt_plugin_VueDeviceDetector_2f3d19cc' // Source: ../plugins/VueDeviceDetector.js (mode: 'client')
import nuxt_plugin_VueZoomer_3da48e70 from 'nuxt_plugin_VueZoomer_3da48e70' // Source: ../plugins/VueZoomer.js (mode: 'client')
import nuxt_plugin_VueApexCharts_1ccfb6de from 'nuxt_plugin_VueApexCharts_1ccfb6de' // Source: ../plugins/VueApexCharts.js (mode: 'client')
import nuxt_plugin_VueQuillEditor_29e7c635 from 'nuxt_plugin_VueQuillEditor_29e7c635' // Source: ../plugins/VueQuillEditor.js (mode: 'client')
import nuxt_plugin_VueHtml2Canvas_88998470 from 'nuxt_plugin_VueHtml2Canvas_88998470' // Source: ../plugins/VueHtml2Canvas.js (mode: 'client')
import nuxt_plugin_VueTree_7df70149 from 'nuxt_plugin_VueTree_7df70149' // Source: ../plugins/VueTree.js (mode: 'client')
import nuxt_plugin_VueMasonryCss_5442b46c from 'nuxt_plugin_VueMasonryCss_5442b46c' // Source: ../plugins/VueMasonryCss.js (mode: 'client')
import nuxt_plugin_VueOrganizationChart_4fbc287b from 'nuxt_plugin_VueOrganizationChart_4fbc287b' // Source: ../plugins/VueOrganizationChart.js (mode: 'client')
import nuxt_plugin_VueViewer_20e71536 from 'nuxt_plugin_VueViewer_20e71536' // Source: ../plugins/VueViewer.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - Kabupaten Klaten","title":"Kabupaten Klaten","htmlAttrs":{"lang":"id","amp":true},"link":[{"rel":"shortcut icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"shortcut icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon.png"},{"rel":"shortcut icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon.png"},{"rel":"shortcut icon","type":"image\u002Fpng","sizes":"64x64","href":"\u002Ffavicon.png"},{"rel":"shortcut icon","type":"image\u002Fpng","sizes":"120x120","href":"\u002Ffavicon.png"},{"rel":"shortcut icon","type":"image\u002Fpng","sizes":"144x144","href":"\u002Ffavicon.png"},{"rel":"shortcut icon","type":"image\u002Fpng","sizes":"152x152","href":"\u002Ffavicon.png"},{"rel":"shortcut icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002Ffavicon.png"},{"rel":"apple-touch-icon","href":"\u002Ffavicon.png"},{"rel":"mask-icon","href":"\u002Ffavicon.png"},{"rel":"ms-tile-image","href":"\u002Ffavicon.png"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Poppins:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"meta":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2387b9a7 === 'function') {
    await nuxt_plugin_plugin_2387b9a7(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_71e973c6 === 'function') {
    await nuxt_plugin_nuxtuseragent_71e973c6(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_7e8debb6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_7e8debb6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_624e9d86 === 'function') {
    await nuxt_plugin_axios_624e9d86(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_057c69ce === 'function') {
    await nuxt_plugin_workbox_057c69ce(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_a7622da8 === 'function') {
    await nuxt_plugin_metaplugin_a7622da8(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_9e12e2c0 === 'function') {
    await nuxt_plugin_iconplugin_9e12e2c0(app.context, inject)
  }

  if (typeof nuxt_plugin_Convert_3777be9b === 'function') {
    await nuxt_plugin_Convert_3777be9b(app.context, inject)
  }

  if (typeof nuxt_plugin_VeeValidate_0a77d762 === 'function') {
    await nuxt_plugin_VeeValidate_0a77d762(app.context, inject)
  }

  if (typeof nuxt_plugin_Axios_4d2fd290 === 'function') {
    await nuxt_plugin_Axios_4d2fd290(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueGoogleMaps_6121fd98 === 'function') {
    await nuxt_plugin_VueGoogleMaps_6121fd98(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueAwesomeSwiper_135329ab === 'function') {
    await nuxt_plugin_VueAwesomeSwiper_135329ab(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueCarousel3d_f3ed7312 === 'function') {
    await nuxt_plugin_VueCarousel3d_f3ed7312(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueBottomNavigation_fd82cf6e === 'function') {
    await nuxt_plugin_VueBottomNavigation_fd82cf6e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueDeviceDetector_2f3d19cc === 'function') {
    await nuxt_plugin_VueDeviceDetector_2f3d19cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueZoomer_3da48e70 === 'function') {
    await nuxt_plugin_VueZoomer_3da48e70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueApexCharts_1ccfb6de === 'function') {
    await nuxt_plugin_VueApexCharts_1ccfb6de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueQuillEditor_29e7c635 === 'function') {
    await nuxt_plugin_VueQuillEditor_29e7c635(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueHtml2Canvas_88998470 === 'function') {
    await nuxt_plugin_VueHtml2Canvas_88998470(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueTree_7df70149 === 'function') {
    await nuxt_plugin_VueTree_7df70149(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueMasonryCss_5442b46c === 'function') {
    await nuxt_plugin_VueMasonryCss_5442b46c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueOrganizationChart_4fbc287b === 'function') {
    await nuxt_plugin_VueOrganizationChart_4fbc287b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueViewer_20e71536 === 'function') {
    await nuxt_plugin_VueViewer_20e71536(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
